import axios from 'axios';
import { CircularProgress, Backdrop, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core';
import React, { PureComponent } from 'react';
import { getAPIUrl } from '../../helpers/CommonHelper';
import '../../styles/CustomerComponent.css';

class CustomerComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      page: 0,
      customer: [],
      rowsPerPage: 10,
      totalItem: 0,
    };
  }

  componentDidMount() {
    this.fetchCustomerDetails();
  }

  fetchCustomerDetails = () => {
    this.setState({
      isLoading: true
    });
    axios.get(`${getAPIUrl()}/admin/customer/all`, {
      timeout: 30000,
      headers: {
        'Authorization': this.props.token
      }
    }).then((resp) => {
      this.setState({
        isLoading: false,
        customer: resp.data.data,
        totalItem: resp.data.totalItem
      });
    }).catch((error) => {
      console.error(error);
      this.setState({
        isLoading: false,
      });
      if (error.response && error.response.status === 401) {
        alert('Session expired!! Please login again');
        this.props.logout();
      } else {
        alert('Something went wrong!!!');
      }
    });
  }

  handleChangePage = (event, newPage) => {
    this.setState({
      page: newPage
    });
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    });
  }

  render() {
    return (
      <Paper className="table-container">
        <TableContainer className="container">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell align="center">EmailId</TableCell>
                <TableCell align="center">First name</TableCell>
                <TableCell align="center">Last name</TableCell>
                <TableCell align="center">Phone number</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.customer.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((row) => {
                return (
                  <TableRow hover key={row.custEmailId}>
                    <TableCell align="center" style={{ maxWidth: 50 }}>
                      {row.custEmailId}
                    </TableCell>
                    <TableCell align="center" style={{ minWidth: 150 }}>
                      {row.custFirstName}
                    </TableCell>
                    <TableCell align="center" style={{ minWidth: 150 }}>
                      {row.custLastName}
                    </TableCell>
                    <TableCell align="center" style={{ maxWidth: 50 }}>
                      {row.custPhoneNumber}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={this.state.totalItem}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          onChangePage={this.handleChangePage}
        />
        <Backdrop className="loading-indicator" open={this.state.isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Paper>
    )
  }
}

export default CustomerComponent;
